import { getFirestore, doc, setDoc, getDoc, collection, addDoc, query, orderBy, limit, getDocs, serverTimestamp } from 'firebase/firestore';
import { auth } from './firebase';

export const db = getFirestore();

export async function saveMetrics(category, data) {
  const user = auth.currentUser;
  if (!user) return;
  const timestamp = serverTimestamp();
  await setDoc(doc(db, 'users', user.uid, 'latest', category), { ...data, updatedAt: timestamp }, { merge: true });
  await addDoc(collection(db, 'users', user.uid, 'history', category, 'entries'), { ...data, recordedAt: timestamp });
}

export async function loadLatestMetrics(category) {
  const user = auth.currentUser;
  if (!user) return null;
  const snap = await getDoc(doc(db, 'users', user.uid, 'latest', category));
  return snap.exists() ? snap.data() : null;
}

export async function loadMetricHistory(category, maxEntries = 6) {
  const user = auth.currentUser;
  if (!user) return [];
  const q = query(collection(db, 'users', user.uid, 'history', category, 'entries'), orderBy('recordedAt', 'desc'), limit(maxEntries));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() })).reverse();
}

export async function loadAllBloodMarkers() {
  const user = auth.currentUser;
  if (!user) return {};
  const [blood, extended] = await Promise.all([
    loadLatestMetrics('blood'),
    loadLatestMetrics('extendedBlood')
  ]);
  return { ...(blood || {}), ...(extended || {}) };
}

export async function saveUserProfile(data) {
  const user = auth.currentUser;
  if (!user) return;
  await setDoc(doc(db, 'users', user.uid, 'latest', 'profile'), { ...data, updatedAt: serverTimestamp() }, { merge: true });
}
